import {
  FOC_TOUR_LABEL_PLN_PSC,
  focFeedbackPopoverHtml,
} from '../focTourFeedback';
import { FOC_PLN_PSC_TOUR_HREF as HREF } from '../focTourHrefs';
import {
  FOC_REQUIRED_DISPOSITION,
  focPlnTourPopoverHtml,
  requirement,
  type FocPlnTourStepDef,
} from './focPlnTourTypes';

export const FOC_PLN_PSC_TOUR_PARAM = 'focPlnPscTour';
export const FOC_PLN_PSC_TOUR_HREF = HREF;
export { focPlnTourPopoverHtml };

export const FOC_PLN_PSC_TOUR_STEPS: FocPlnTourStepDef[] = [
  {
    id: 'sectionIntro',
    tour: 'position-workspace-root',
    title: FOC_TOUR_LABEL_PLN_PSC,
    description:
      'The Planning Section Chief workspace manages the Planning P, IAP component tracker, Planning Pulse, incident documentation, operational-period products, readiness, cross-section coordination, IAP assembly, approval readiness, and post-incident documentation.',
  },
  requirement({
    id: 'pln001',
    requirementId: 'FOC-PLN-001',
    name: 'Planning Section Chief Workspace',
    disposition: FOC_REQUIRED_DISPOSITION,
    tour: 'position-workspace-root',
    description:
      'PRATUS provides a Planning Section Chief workspace for managing the Planning P, IAP component tracker, Planning Pulse, incident documentation, operational-period products, product readiness, coordination across incident sections, IAP assembly, approval readiness, and post-incident documentation requirements.',
    bullets: [
      'FOC-PLN-001a — Planning Pulse: consolidated view of required products; owners; responsible section/unit; operational period; status; readiness; blockers; dependencies; required approvals; IAP completeness; open actions; resource-request dependencies; safety issues; logistics/finance constraints; due timing.',
    ],
  }),
  {
    id: 'focFeedback',
    title: 'FOC Feedback Notes',
    description: focFeedbackPopoverHtml(FOC_TOUR_LABEL_PLN_PSC),
  },
];
